(function () {
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var overlay;

  function open(el) { if (!el) return; el.classList.add('is-open'); overlay.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
  function closeAll() { $$('.drawer.is-open,.mobile-nav.is-open').forEach(function (e) { e.classList.remove('is-open'); }); overlay.classList.remove('is-open'); document.body.style.overflow = ''; }

  function refreshCart(show) {
    return fetch(window.routes.root + '?section_id=cart-drawer')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = $('#CartDrawer', doc), cur = $('#CartDrawer');
        if (fresh && cur) {
          cur.innerHTML = fresh.innerHTML;
          var n = fresh.getAttribute('data-count');
          $$('[data-cart-count]').forEach(function (b) { b.textContent = n; b.hidden = n === '0'; });
          if (show) open(cur);
        }
      });
  }

  function changeLine(key, qty) {
    return fetch(window.routes.cartChange, {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function () { return refreshCart(true); });
  }

  document.addEventListener('DOMContentLoaded', function () {
    overlay = $('#Overlay');
    if (!overlay) { overlay = document.createElement('div'); overlay.id = 'Overlay'; overlay.className = 'overlay'; document.body.appendChild(overlay); }
    overlay.addEventListener('click', closeAll);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });

    document.addEventListener('click', function (e) {
      var t = e.target.closest('[data-open-cart],[data-open-menu],[data-close],[data-line-qty],[data-line-remove],[data-qty],[data-carousel],[data-thumb]');
      if (!t) return;
      if (t.hasAttribute('data-open-cart') && $('#CartDrawer')) { e.preventDefault(); open($('#CartDrawer')); }
      else if (t.hasAttribute('data-open-menu')) { open($('#MobileNav')); }
      else if (t.hasAttribute('data-close')) { closeAll(); }
      else if (t.hasAttribute('data-line-qty')) { changeLine(t.getAttribute('data-key'), parseInt(t.getAttribute('data-line-qty'), 10)); }
      else if (t.hasAttribute('data-line-remove')) { changeLine(t.getAttribute('data-key'), 0); }
      else if (t.hasAttribute('data-qty')) {
        var input = $('input', t.parentNode);
        input.value = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(t.getAttribute('data-qty'), 10));
      }
      else if (t.hasAttribute('data-carousel')) {
        var track = $('.carousel', t.closest('section') || document);
        if (track) track.scrollBy({ left: parseInt(t.getAttribute('data-carousel'), 10) * track.clientWidth * 0.8, behavior: 'smooth' });
      }
      else if (t.hasAttribute('data-thumb')) {
        var main = $('[data-gallery-main]');
        if (main) { main.innerHTML = '<img src="' + t.getAttribute('data-thumb') + '" alt="">'; }
        $$('[data-thumb]').forEach(function (b) { b.classList.toggle('is-active', b === t); });
      }
    });

    // close desktop dropdowns when clicking elsewhere
    document.addEventListener('click', function (e) {
      $$('.header__nav details[open]').forEach(function (d) { if (!d.contains(e.target)) d.removeAttribute('open'); });
    });

    // ajax add to cart
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.matches('form[data-product-form]')) return;
      e.preventDefault();
      var btn = $('[type=submit]', form);
      if (btn) btn.disabled = true;
      fetch(window.routes.cartAdd, { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); return refreshCart(true); })
        .catch(function () { form.removeAttribute('data-product-form'); form.submit(); })
        .then(function () { if (btn) btn.disabled = false; });
    });

    // variant picker
    var data = $('#VariantData');
    if (data) {
      var variants = JSON.parse(data.textContent);
      var form = $('form[data-product-form]');
      var update = function () {
        var chosen = $$('.option input:checked').map(function (i) { return i.value; });
        var v = variants.filter(function (x) { return x.options.every(function (o, i) { return o === chosen[i]; }); })[0];
        if (!v) return;
        $$('input[name=id]').forEach(function (i) { i.value = v.id; });
        $$('[data-price]', $('#ProductInfo')).forEach(function (p) { p.textContent = v.price; });
        $$('[data-compare]', $('#ProductInfo')).forEach(function (p) { p.textContent = v.compare; p.hidden = !v.compare; });
        $$('[data-sticky-price]').forEach(function (p) { p.textContent = v.price; });
        $$('[data-save]').forEach(function (p) { p.textContent = v.save; p.hidden = !v.save; });
        $$('[data-atc]').forEach(function (b) { b.disabled = !v.available; b.textContent = v.available ? b.getAttribute('data-label') : 'Uitverkocht'; });
        if (v.image) { var th = $('[data-thumb="' + v.image + '"]'); if (th) th.click(); }
        var url = new URL(window.location.href); url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url);
      };
      $$('.option input').forEach(function (i) { i.addEventListener('change', update); });

      var sticky = $('#StickyAtc');
      if (sticky && form && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (en) { sticky.classList.toggle('is-visible', !en[0].isIntersecting && en[0].boundingClientRect.top < 0); }).observe(form);
      }
    }

    // sort select
    var sort = $('#SortBy');
    if (sort) sort.addEventListener('change', function () {
      var url = new URL(window.location.href); url.searchParams.set('sort_by', sort.value); window.location = url;
    });
  });
})();
